import React from 'react'
import PropTypes from 'prop-types'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

function MyTooltip(props) {
  const { tips, children } = props
  const renderTooltip = (data) => (
    <Tooltip id='button-tooltip' {...data}>
      {tips}
    </Tooltip>
  )
  return (
    <OverlayTrigger placement={props.direction || 'bottom'} delay={{ show: 1000, hide: 0 }} overlay={renderTooltip}>
      {children}
    </OverlayTrigger>
  )
}

MyTooltip.propTypes = {
  tips: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
}

export default MyTooltip
